/* Khadiga theme — storefront interactions (no dependencies). */
(() => {
  'use strict';
  const K = window.KH || { s: {} };
  const S = K.s;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rtl = document.dir === 'rtl';
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const norm = s => String(s || '').trim().toLowerCase();
  const sub = (str, k, v) => String(str || '').replace('{' + k + '}', v);

  /* ---------------- Money ---------------- */
  function money(cents) {
    const fmt = K.moneyFormat || '{{amount}}';
    const n = (cents || 0) / 100;
    const f = (d, t, dec) => {
      const [i, frac] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (frac ? dec + frac : '');
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const val = { amount: f(2, ',', '.'), amount_no_decimals: f(0, ',', '.'), amount_with_comma_separator: f(2, '.', ','), amount_no_decimals_with_comma_separator: f(0, '.', ','), amount_with_apostrophe_separator: f(2, "'", '.') }[key] || f(2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  /* ---------------- Micro-interactions ---------------- */
  let toastT;
  function toast(msg) {
    const t = $('#toast');
    if (!t) return;
    t.querySelector('span').textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('on'), 2400);
  }
  function shake(...els) {
    els.forEach(el => {
      if (!el) return;
      el.classList.remove('shake'); void el.offsetWidth; el.classList.add('shake');
      el.addEventListener('animationend', () => el.classList.remove('shake'), { once: true });
    });
  }
  function pop(el) { if (!el) return; el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.9-4.8-9.8-9.9C.9 7.6 3.2 4 6.9 4c2.1 0 3.5 1 5.1 3 1.6-2 3-3 5.1-3 3.7 0 6 3.6 4.7 7.1C19.9 16.2 12 21 12 21z"/></svg>';
  const SHAPES = [HEART, '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c.7 5.3 3.9 8.6 9.2 9.3-5.3.7-8.5 4-9.2 9.2-.7-5.2-4-8.5-9.2-9.2C8.1 10.6 11.3 7.3 12 2z"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 22 12 12 22 2 12z"/></svg>', HEART];
  const brand = () => getComputedStyle(document.documentElement).getPropertyValue('--brand-2').trim() || '#b01e68';
  function hearts(from) {
    if (reduce || !from) return;
    const r = from.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    const shades = ['#9a1457', '#7c0f45', brand(), '#9a1457', '#c23a7c'];
    for (let i = 0; i < 10; i++) {
      const h = document.createElement('span');
      h.className = 'fly-heart'; h.innerHTML = HEART;
      const size = 12 + Math.random() * 14;
      h.style.cssText = `left:${cx - size / 2}px;top:${cy - size / 2}px;width:${size}px;height:${size}px;color:${shades[i % shades.length]}`;
      document.body.appendChild(h);
      const dx = (Math.random() - 0.5) * 160, dy = -(120 + Math.random() * 160), rot = (Math.random() - 0.5) * 50;
      h.animate([
        { transform: 'translate(0,0) scale(.2)', opacity: 0 },
        { transform: `translate(${dx * 0.3}px,${dy * 0.25}px) scale(1) rotate(${rot * 0.4}deg)`, opacity: 1, offset: 0.18 },
        { transform: `translate(${dx * 0.75}px,${dy * 0.7}px) scale(.95) rotate(${rot}deg)`, opacity: 0.85, offset: 0.7 },
        { transform: `translate(${dx}px,${dy}px) scale(.7) rotate(${rot * 1.2}deg)`, opacity: 0 },
      ], { duration: 2200 + Math.random() * 1400, delay: i * 90, easing: 'cubic-bezier(.25,.7,.3,1)', fill: 'both' }).onfinish = () => h.remove();
    }
  }
  function shower() {
    if (reduce || !K.shower) return;
    const W = innerWidth, H = innerHeight;
    const colors = ['#9a1457', '#7c0f45', brand(), '#c23a7c', '#e5a3c3', '#c9a27a'];
    const n = W < 600 ? 22 : 34;
    for (let i = 0; i < n; i++) {
      const el = document.createElement('span');
      el.className = 'fly-heart'; el.innerHTML = SHAPES[i % SHAPES.length];
      const size = 12 + Math.random() * 18;
      const from = i % 3 === 0 ? 'left' : i % 3 === 1 ? 'right' : 'top';
      const x0 = from === 'left' ? -30 : from === 'right' ? W + 10 : Math.random() * W;
      const y0 = from === 'top' ? -40 - Math.random() * 60 : Math.random() * H * 0.35;
      const dx = from === 'left' ? 80 + Math.random() * W * 0.35 : from === 'right' ? -(80 + Math.random() * W * 0.35) : (Math.random() - 0.5) * 160;
      const dy = H * (0.55 + Math.random() * 0.5), rot = (Math.random() - 0.5) * 540, sway = (Math.random() - 0.5) * 70;
      el.style.cssText = `left:${x0}px;top:${y0}px;width:${size}px;height:${size}px;color:${colors[i % colors.length]}`;
      document.body.appendChild(el);
      el.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 0 },
        { transform: `translate(${dx * 0.3 + sway}px,${dy * 0.25}px) rotate(${rot * 0.3}deg)`, opacity: 1, offset: 0.15 },
        { transform: `translate(${dx * 0.7 - sway}px,${dy * 0.65}px) rotate(${rot * 0.7}deg)`, opacity: 0.9, offset: 0.65 },
        { transform: `translate(${dx}px,${dy}px) rotate(${rot}deg)`, opacity: 0 },
      ], { duration: 2600 + Math.random() * 1800, delay: Math.random() * 450, easing: 'cubic-bezier(.3,.6,.4,1)', fill: 'both' }).onfinish = () => el.remove();
    }
  }

  /* ---------------- Overlays ---------------- */
  const scrim = $('#scrim');
  let openEl = null, lastFocus = null;
  function open(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openEl && openEl !== el) close();
    lastFocus = document.activeElement;
    openEl = el;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    if (id === 'cart') refreshCart();
    if (id === 'search') setTimeout(() => $('#searchInput') && $('#searchInput').focus(), 60);
    else setTimeout(() => { const c = el.querySelector('[data-close]'); c && c.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('open');
    openEl.setAttribute('aria-hidden', 'true');
    scrim && scrim.classList.remove('on');
    document.documentElement.style.overflow = '';
    openEl = null;
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  scrim && scrim.addEventListener('click', close);
  addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  /* ---------------- Wishlist (localStorage, product handles) ---------------- */
  const wish = {
    get() { try { return JSON.parse(localStorage.getItem('kh_wish') || '[]').filter(x => typeof x === 'string'); } catch (e) { return []; } },
    set(v) { try { localStorage.setItem('kh_wish', JSON.stringify(v)); } catch (e) { /* private mode */ } },
    toggle(h) { const w = wish.get(); const i = w.indexOf(h); if (i >= 0) w.splice(i, 1); else w.push(h); wish.set(w); return i < 0; },
  };
  function syncWish() {
    const w = wish.get();
    $$('[data-wish-count]').forEach(el => { el.textContent = String(w.length); el.classList.toggle('on', w.length > 0); });
    $$('[data-wish]').forEach(b => {
      const on = w.includes(b.dataset.wish);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? S.removeWish : S.addWish);
    });
  }

  /* ---------------- Cart (Shopify AJAX API) ---------------- */
  let cartState = null;
  const R = K.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const api = (url, body) => fetch(url + '.js', body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async r => { const j = await r.json(); if (!r.ok) throw j; return j; });
  async function refreshCart() {
    try { cartState = await api(R.cart); } catch (e) { return; }
    renderCart();
  }
  const waOnly = c => K.waLimit > 0 && c && c.total_price > K.waLimit;
  function waCartLink(c) {
    const lines = c.items.map(i => `• ${i.product_title}${i.variant_title ? ' (' + i.variant_title + ')' : ''}${i.properties && i.properties._bundle ? ' [' + S.bundleTag + ']' : ''} × ${i.quantity} = ${money(i.final_line_price)}`);
    return `https://wa.me/${K.wa}?text=${encodeURIComponent([S.waOrderHi, ...lines, '', `${S.waOrderTotal}: ${money(c.total_price)}`].join('\n'))}`;
  }
  function renderCart() {
    const c = cartState;
    if (!c) return;
    $$('[data-cart-count]').forEach(el => { el.textContent = String(c.item_count); el.classList.toggle('on', c.item_count > 0); });
    renderStock();
    const body = $('#cartBody'), foot = $('#cartFoot');
    if (!body || !foot) return;
    if (!c.item_count) {
      body.innerHTML = `<div class="empty"><span class="ring"><svg class="ico"><use href="#i-bag"/></svg></span><h3>${esc(S.emptyCart)}</h3><p>${esc(S.emptyCartSub)}</p><a class="btn btn-primary btn-sm" href="${esc(K.routes.all)}" style="margin-top:8px">${esc(S.continueShopping)}</a></div>`;
      foot.hidden = true;
      return;
    }
    let ship = '';
    if (K.free > 0) {
      const left = Math.max(0, K.free - c.total_price), pct = Math.min(100, (c.total_price / K.free) * 100);
      ship = `<div class="ship-bar">${left > 0 ? esc(sub(S.freeShipLeft, 'x', '\u0000')).replace('\u0000', `<b>${esc(money(left))}</b>`) : esc(S.freeShipOk)}<div class="track"><div class="fill" style="width:${pct}%"></div></div></div>`;
    }
    body.innerHTML = ship + c.items.map((i, n) => `<div class="ci">
      <a href="${esc(i.url)}">${i.image ? `<img src="${esc(i.image)}${i.image.includes('?') ? '&' : '?'}width=160" alt="" width="78" height="110" loading="lazy">` : ''}</a>
      <div><h3><a href="${esc(i.url)}">${esc(i.product_title)}</a>${i.properties && i.properties._bundle ? ` <span class="ci-bundle">${esc(S.bundleTag)}</span>` : ''}</h3>
        ${i.variant_title ? `<p class="meta">${esc(i.variant_title.replace(/ \/ /g, ' · '))}</p>` : ''}
        <p class="pr">${i.original_line_price > i.final_line_price ? `<s>${esc(money(i.original_line_price))}</s> ` : ''}${esc(money(i.final_line_price))}</p>
        <div class="qty"><button type="button" data-cq="-" data-line="${n + 1}" data-q="${i.quantity}" aria-label="-"><svg class="ico ico-sm"><use href="#i-minus"/></svg></button><span>${i.quantity}</span><button type="button" data-cq="+" data-line="${n + 1}" data-q="${i.quantity}" aria-label="+"><svg class="ico ico-sm"><use href="#i-plus"/></svg></button></div>
      </div>
      <button type="button" class="rm" data-cq="rm" data-line="${n + 1}">${esc(S.remove)}</button>
    </div>`).join('');
    $('#cartSubtotal').textContent = money(c.total_price);
    const wo = $('#cartWaOnly'), co = $('#cartCheckoutForm');
    const only = waOnly(c);
    if (wo) {
      wo.hidden = !only;
      if (only) wo.innerHTML = `<p><b>${esc(sub(S.waOnlyTitle, 'x', money(K.waLimit)))}</b><br>${esc(sub(S.waOnlySub, 'x', money(K.waLimit)))}</p><a class="btn wa-btn btn-block" href="${esc(waCartLink(c))}" target="_blank" rel="noopener"><svg><use href="#i-wa"/></svg>${esc(S.waOnlyBtn)}</a>`;
    }
    if (co) co.hidden = only;
    foot.hidden = false;
  }
  async function addItems(items, btn) {
    try {
      await api(R.cartAdd, { items });
    } catch (e) {
      toast((e && (e.description || e.message)) || S.unavailable);
      shake(btn);
      return false;
    }
    shake(btn, $('#cartIcon'));
    shower();
    toast(S.added);
    await refreshCart();
    return true;
  }

  /* ---------------- Stock bars (live: stock minus what's in the bag) ---------------- */
  function renderStock() {
    if (!K.showStock) return;
    const inCart = {};
    (cartState ? cartState.items : []).forEach(i => (inCart[i.product_id] = (inCart[i.product_id] || 0) + i.quantity));
    $$('[data-stock]').forEach(el => {
      if (el.classList.contains('sel-out')) return;
      const base = +el.dataset.qty, q = inCart[el.dataset.stock] || 0;
      if (isNaN(base)) return;
      const left = Math.max(0, base - q);
      const pct = Math.max(left ? 6 : 0, Math.min(100, (left / (K.stockMax || 25)) * 100));
      el.classList.toggle('low', left > 0 && left <= (K.stockLow || 5));
      el.classList.toggle('out', left === 0);
      el.querySelector('.sb-fill').style.width = pct + '%';
      el.querySelector('[data-st-text]').textContent = left === 0 ? S.stockOut : left === 1 ? S.stockOne : sub(S.stockLeft, 'n', left);
      const c = el.querySelector('[data-st-cart]');
      if (c) c.textContent = q ? sub(S.inYourCart, 'n', q) : '';
    });
  }

  /* ---------------- Variant picker (product page, quick view, bundles) ---------------- */
  function readProduct(root) {
    const s = root.querySelector('script[data-product-json]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function mountPicker(root, p, opts = {}) {
    const groups = $$('[data-opt]', root);
    const n = p.options.length;
    const sel = groups.map(g => { const on = g.querySelector('[aria-checked="true"]'); return on ? on.dataset.v : null; });
    const match = (v, s, skip) => s.every((x, i) => i === skip || x == null || v.options[i] === x);
    const avail = (s, skip) => p.variants.some(v => v.available && match(v, s, skip));
    const current = () => (sel.length === n && sel.every(x => x != null) ? p.variants.find(v => v.options.every((o, i) => o === sel[i])) : null) || (n === 1 && p.options[0] === 'Title' ? p.variants[0] : null);
    function refresh() {
      groups.forEach((g, gi) => {
        $$('[data-v]', g).forEach(b => {
          const test = sel.slice(); test[gi] = b.dataset.v;
          b.setAttribute('aria-checked', String(b.dataset.v === sel[gi]));
          b.classList.toggle('na', !avail(test, -1));
        });
        const cur = g.querySelector('[data-cur]');
        if (cur) cur.textContent = sel[gi] || '';
      });
      const v = current();
      opts.onChange && opts.onChange(v, sel.slice());
    }
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-v]');
      if (!b || !root.contains(b)) return;
      const g = b.closest('[data-opt]');
      const gi = groups.indexOf(g);
      if (gi < 0) return;
      sel[gi] = b.dataset.v;
      pop(b);
      refresh();
      if (p.colorPos && gi === p.colorPos - 1) opts.onColor && opts.onColor(sel[gi]);
    });
    // start on an in-stock variant
    if (!current() || !current().available) {
      const first = p.variants.find(v => v.available);
      if (first) first.options.forEach((o, i) => (sel[i] = o));
    }
    refresh();
    return {
      sel, current, ready: () => !!current(),
      missing: () => groups[sel.findIndex(x => x == null)] || null,
    };
  }
  const colorMedia = (p, color) => {
    const key = norm(color);
    const byAlt = p.media.filter(m => norm(m.alt) === key);
    if (byAlt.length) return byAlt;
    if (!p.colorPos) return [];
    // No alt text: group photos by each colour's variant photo. A colour owns its variant photo plus the
    // photos right after it, up to the next colour's photo (the order the store keeps its photos in).
    const idxOf = id => p.media.findIndex(m => m.id === id);
    const starts = {};
    p.variants.forEach(x => {
      const c = norm(x.options[p.colorPos - 1]);
      const i = x.media ? idxOf(x.media) : -1;
      if (i >= 0 && !(c in starts)) starts[c] = i;
    });
    if (!(key in starts)) return [];
    const sorted = [...new Set(Object.values(starts))].sort((m, n) => m - n);
    const s = starts[key], next = sorted.find(i => i > s);
    return p.media.slice(s, next == null ? p.media.length : next);
  };

  /* ---------------- Product page ---------------- */
  function initProduct() {
    const root = $('#pdp');
    if (!root) return;
    const p = readProduct(root);
    if (!p) return;
    const track = $('#gTrack');
    const allSlides = $$('.g-slide', track);
    const allThumbs = $$('#gThumbs [data-t]');
    const cur = $('#gCur'), tot = $('#gTot');
    let slides = allSlides.slice(), thumbs = allThumbs.slice(), idx = 0;
    const baseAt = i => (slides[i] && slides[i].dataset.base) || '';
    const mark = () => {
      if (cur) cur.textContent = String(idx + 1);
      thumbs.forEach((t, i) => t.classList.toggle('on', i === idx));
      thumbs[idx] && thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    const go = (i, smooth = true) => {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      mark();
    };
    const showColor = color => {
      const ids = new Set(colorMedia(p, color).map(m => String(m.id)));
      const keep = ids.size > 0;
      allSlides.forEach((s, i) => {
        const on = !ids.size ? true : keep ? ids.has(s.dataset.mid) : true;
        s.hidden = !on; if (allThumbs[i]) allThumbs[i].hidden = !on;
      });
      slides = allSlides.filter(s => !s.hidden);
      thumbs = allThumbs.filter(t => !t.hidden);
      if (tot) tot.textContent = String(slides.length);
      track.classList.remove('g-swap'); void track.offsetWidth; track.classList.add('g-swap');
      let start = 0;
      if (ids.size && !keep) start = Math.max(0, slides.findIndex(s => ids.has(s.dataset.mid)));
      go(start, false);
    };
    let raf = 0;
    track && track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; mark(); } });
    }, { passive: true });
    allThumbs.forEach(t => t.addEventListener('click', () => go(thumbs.indexOf(t))));
    $$('[data-g]', root).forEach(b => b.addEventListener('click', () => go(idx + +b.dataset.g)));

    // Lens zoom (desktop)
    const main = $('.g-main', root);
    const canZoom = () => matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches;
    const Z = 2.6;
    const lens = document.createElement('div'); lens.className = 'zoom-lens';
    const pane = document.createElement('div'); pane.className = 'zoom-pane'; pane.setAttribute('aria-hidden', 'true');
    $('.glow-in', main).appendChild(lens); root.appendChild(pane);
    let box = null;
    const place = () => {
      const pr = root.getBoundingClientRect(), mr = main.getBoundingClientRect(), gap = 24;
      const w = rtl ? mr.left - pr.left - gap : pr.right - mr.right - gap;
      Object.assign(pane.style, { width: w + 'px', height: mr.height + 'px', top: mr.top - pr.top + 'px', left: (rtl ? mr.left - pr.left - gap - w : mr.right - pr.left + gap) + 'px', backgroundSize: `${mr.width * Z}px ${mr.height * Z}px` });
      lens.style.width = w / Z + 'px'; lens.style.height = mr.height / Z + 'px';
    };
    const move = e => {
      if (!box) return;
      const lw = lens.offsetWidth, lh = lens.offsetHeight;
      const x = Math.max(0, Math.min(box.width - lw, e.clientX - box.left - lw / 2));
      const y = Math.max(0, Math.min(box.height - lh, e.clientY - box.top - lh / 2));
      lens.style.transform = `translate(${x}px,${y}px)`;
      pane.style.backgroundPosition = `-${x * Z}px -${y * Z}px`;
    };
    const start = e => {
      if (!canZoom() || e.target.closest('button') || !baseAt(idx)) return;
      box = main.getBoundingClientRect();
      pane.style.backgroundImage = `url(${baseAt(idx)})`;
      place(); main.classList.add('zooming'); pane.classList.add('on'); move(e);
    };
    main.addEventListener('pointerenter', start);
    main.addEventListener('pointermove', e => {
      if (!box) { start(e); return; }
      const over = e.target.closest('.g-nav, .pc-badges');
      main.classList.toggle('zooming', !over); pane.classList.toggle('on', !over); move(e);
    });
    main.addEventListener('pointerleave', () => { box = null; main.classList.remove('zooming'); pane.classList.remove('on'); });
    addEventListener('scroll', () => { if (box) { box = main.getBoundingClientRect(); place(); } }, { passive: true });

    // Touch loupe (press & hold)
    const loupe = document.createElement('div'); loupe.className = 'zoom-loupe'; loupe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(loupe);
    const LZ = 2.4;
    let holdT = 0, active = false, sx = 0, sy = 0, mbox = null;
    const lmove = (cx, cy) => {
      if (!mbox) return;
      const x = Math.max(0, Math.min(mbox.width, cx - mbox.left)), y = Math.max(0, Math.min(mbox.height, cy - mbox.top));
      const d = loupe.offsetWidth;
      let top = cy - d - 34; if (top < 8) top = cy + 34;
      const left = Math.max(8, Math.min(innerWidth - d - 8, cx - d / 2));
      loupe.style.transform = `translate(${left}px,${top}px)`;
      loupe.style.backgroundPosition = `${-(x * LZ - d / 2)}px ${-(y * LZ - d / 2)}px`;
    };
    const lstart = (cx, cy) => {
      if (!baseAt(idx)) return;
      active = true; mbox = main.getBoundingClientRect();
      loupe.style.backgroundImage = `url(${baseAt(idx)})`;
      loupe.style.backgroundSize = `${mbox.width * LZ}px ${mbox.height * LZ}px`;
      loupe.classList.add('on'); main.classList.add('loupe-on');
      navigator.vibrate && navigator.vibrate(8);
      lmove(cx, cy);
    };
    const lend = () => { clearTimeout(holdT); if (!active) return; active = false; mbox = null; loupe.classList.remove('on'); main.classList.remove('loupe-on'); };
    main.addEventListener('touchstart', e => {
      if (e.touches.length !== 1 || e.target.closest('button')) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      clearTimeout(holdT); holdT = setTimeout(() => lstart(sx, sy), 220);
    }, { passive: true });
    main.addEventListener('touchmove', e => {
      const t = e.touches[0];
      if (active) { e.preventDefault(); lmove(t.clientX, t.clientY); return; }
      if (Math.hypot(t.clientX - sx, t.clientY - sy) > 10) clearTimeout(holdT);
    }, { passive: false });
    main.addEventListener('touchend', lend);
    main.addEventListener('touchcancel', lend);
    main.addEventListener('contextmenu', e => { if (active || matchMedia('(pointer: coarse)').matches) e.preventDefault(); });

    // Buying
    const form = $('#pForm'), vInput = $('#pVariant'), qty = $('#pQty');
    const q = () => Math.max(1, Math.min(99, +qty.value || 1));
    $$('[data-q]', root).forEach(b => b.addEventListener('click', () => (qty.value = String(Math.max(1, Math.min(99, q() + +b.dataset.q))))));
    const addBtn = $('#pAdd'), nBtn = $('#pNotifyBtn'), nForm = $('#pNotify'), row2 = $('#pBuyRow2');
    const priceEl = $('#pPrice'), cmpEl = $('#pCmp'), stockEl = $('#pStock');
    let selVariant = null, selNames = [];
    const selName = () => [p.title, ...selNames.filter(Boolean)].join(' — ');
    const picker = mountPicker($('#pPick') || root, p, {
      onColor: showColor,
      onChange(v, names) {
        selVariant = v; selNames = names;
        if (v) {
          vInput.value = v.id;
          priceEl.textContent = money(v.price);
          if (cmpEl) { cmpEl.hidden = !(v.compare > v.price); cmpEl.textContent = money(v.compare); }
          if (history.replaceState && !document.body.classList.contains('template-index')) {
            const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
          }
        }
        const out = !!v && !v.available;
        if (stockEl) { stockEl.classList.toggle('out', out || !v); stockEl.textContent = out ? S.soldOut : v ? S.inStock : S.unavailable; }
        addBtn.hidden = out; nBtn.hidden = !out; if (row2) row2.hidden = out;
        if (!out && nForm) nForm.hidden = true;
        const nb = $('#pNotifyBody'); if (nb) nb.value = selName() + '\n' + location.href;
        const nwa = $('#pNotifyWa');
        if (nwa) nwa.href = `https://wa.me/${K.wa}?text=${encodeURIComponent((K.lang === 'ar' ? 'السلام عليكم، عايزة أعرف إمتى يتوفر: ' : 'Hello, when will this be available: ') + selName() + '\n' + location.href)}`;
        const sb = $('.pinfo .stock-bar', root);
        if (sb) {
          if (v && v.qty != null) { sb.dataset.qty = Math.max(0, v.qty); sb.classList.remove('sel-out'); renderStock(); }
          if (out) { sb.classList.add('out', 'sel-out'); sb.classList.remove('low'); sb.querySelector('[data-st-text]').textContent = S.stockOut; }
        }
      },
    });
    if (p.colorPos && picker.sel[p.colorPos - 1]) showColor(picker.sel[p.colorPos - 1]);
    const ensure = btn => {
      if (!picker.ready()) { shake(picker.missing() || $('#pPick')); toast(S.selectOptions); return false; }
      if (!selVariant.available) { shake(btn); toast(S.soldOut); return false; }
      return true;
    };
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!ensure(addBtn)) return;
      await addItems([{ id: selVariant.id, quantity: q() }], addBtn);
    });
    $('#pBuy') && $('#pBuy').addEventListener('click', async e => {
      if (!ensure(e.currentTarget)) return;
      if (await addItems([{ id: selVariant.id, quantity: q() }], e.currentTarget)) setTimeout(() => (location.href = waOnly(cartState) ? R.cart : '/checkout'), 500);
    });
    const stickyAdd = $('[data-sticky-add]');
    stickyAdd && stickyAdd.addEventListener('click', e => {
      if (!picker.ready()) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); shake($('#pPick')); return; }
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    const sticky = $('#stickyBuy');
    if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sticky.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
    // WhatsApp order with the current selection
    const wa = $('#pWa');
    if (wa) {
      const href = () => {
        const lines = K.lang === 'ar'
          ? [`مرحباً، عايزة أطلب: ${p.title}`, ...selNames.filter(Boolean), `الكمية: ${q()}`, location.href]
          : [`Hi, I'd like to order: ${p.title}`, ...selNames.filter(Boolean), `Qty: ${q()}`, location.href];
        return `https://wa.me/${K.wa}?text=${encodeURIComponent(lines.join('\n'))}`;
      };
      ['pointerdown', 'focus'].forEach(ev => wa.addEventListener(ev, () => (wa.href = href())));
      wa.href = href();
    }
    // Notify me
    if (nForm) {
      if (nForm.querySelector('.coupon-msg.ok')) { nForm.hidden = false; toast(sub(S.notifyDone, 'x', p.title)); }
      nBtn.addEventListener('click', () => { nForm.hidden = false; nBtn.hidden = true; const i = nForm.querySelector('input[type=tel]'); i && i.focus(); });
      nForm.addEventListener('submit', e => {
        const inp = nForm.querySelector('input[type=tel]');
        const digits = inp.value.replace(/[^\d٠-٩]/g, '').replace(/[٠-٩]/g, c => String('٠١٢٣٤٥٦٧٨٩'.indexOf(c)));
        if (!/^(\+?20)?0?1[0125]\d{8}$/.test(digits)) { e.preventDefault(); shake(inp); inp.classList.add('err'); toast(S.invalidPhone); return; }
        const nb = $('#pNotifyBody'); if (nb) nb.value = selName() + '\n' + digits + '\n' + location.href;
      });
    }
  }

  /* ---------------- Quick view ---------------- */
  async function quickView(handle) {
    const body = $('#quickBody');
    if (!body) return;
    let html = '';
    try { html = await fetch(`${K.root.replace(/\/$/, '')}/products/${handle}?section_id=quick-view`).then(r => r.text()); } catch (e) { location.href = `/products/${handle}`; return; }
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const qv = tmp.querySelector('[data-qv]');
    if (!qv) { location.href = `/products/${handle}`; return; }
    body.innerHTML = ''; body.appendChild(qv);
    const p = readProduct(qv);
    const img = $('#qvImg', qv), price = $('#qvPrice', qv), vIn = $('[data-variant-input]', qv), qin = $('[data-qty]', qv);
    let list = p.media.slice(), v = null;
    const setImg = i => { if (!list[i]) return; img.src = list[i].m; $$('[data-qi]', qv).forEach((b, k) => b.classList.toggle('on', k === i)); };
    const picker = mountPicker($('[data-pick]', qv), p, {
      onChange(cur) { v = cur; if (cur) { vIn.value = cur.id; price.textContent = money(cur.price); } },
      onColor(c) { const m = colorMedia(p, c); list = m.length ? m : p.media.slice(); $$('[data-qi]', qv).forEach((b, k) => (b.hidden = k >= list.length)); setImg(0); },
    });
    if (p.colorPos && picker.sel[p.colorPos - 1]) { const m = colorMedia(p, picker.sel[p.colorPos - 1]); if (m.length) { list = m; setImg(0); } }
    qv.addEventListener('click', e => {
      const qi = e.target.closest('[data-qi]'); if (qi) setImg(+qi.dataset.qi);
      const qq = e.target.closest('[data-qq]'); if (qq) qin.value = String(Math.max(1, Math.min(99, (+qin.value || 1) + (qq.dataset.qq === '+' ? 1 : -1))));
    });
    $('form', qv).addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('[data-add]', qv);
      if (!picker.ready()) { shake(picker.missing()); toast(S.selectOptions); return; }
      if (!v.available) { shake(btn); toast(S.soldOut); return; }
      if (await addItems([{ id: v.id, quantity: Math.max(1, +qin.value || 1) }], btn)) setTimeout(() => { close(); open('cart'); }, 650);
    });
    syncWish(); renderStock();
    open('quick');
  }

  /* ---------------- Bundles ---------------- */
  function initBundles() {
    $$('[data-bundle]').forEach(card => {
      const items = $$('[data-bundle-item]', card).map(el => {
        const p = readProduct(el);
        const imgEl = $('[data-bimg]', el);
        let v = null;
        const pick = $('[data-pick]', el);
        const pk = pick ? mountPicker(pick, p, {
          onChange(cur) { v = cur; el.classList.toggle('out', !!cur && !cur.available); },
          onColor(c) { const m = colorMedia(p, c); if (m.length && imgEl) imgEl.src = m[0].m; },
        }) : null;
        if (!pk) v = p.variants.find(x => x.available) || p.variants[0];
        return { el, p, get v() { return v; }, pk };
      });
      const btn = $('[data-bundle-add]', card);
      btn && btn.addEventListener('click', async () => {
        for (const it of items) {
          if (it.pk && !it.pk.ready()) { shake(it.el); toast(S.selectOptions); return; }
          if (!it.v || !it.v.available) { shake(it.el); toast(S.soldOut); return; }
        }
        if (await addItems(items.map(it => ({ id: it.v.id, quantity: 1, properties: { _bundle: card.dataset.bundle } })), btn)) toast(S.bundleAdded);
      });
    });
  }

  /* ---------------- Search (predictive) ---------------- */
  function initSearch() {
    const input = $('#searchInput'), res = $('#searchResults');
    if (!input || !res) return;
    const def = res.innerHTML;
    let t = 0, ctl = null;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!q) { res.innerHTML = def; return; }
      t = setTimeout(async () => {
        ctl && ctl.abort(); ctl = new AbortController();
        try {
          const j = await fetch(`${K.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`, { signal: ctl.signal }).then(r => r.json());
          const hits = (j.resources && j.resources.results && j.resources.results.products) || [];
          res.innerHTML = hits.length
            ? hits.map(h => `<a class="sr-item" href="${esc(h.url)}">${h.image ? `<img src="${esc(h.image)}${h.image.includes('?') ? '&' : '?'}width=120" alt="" width="52" height="70" loading="lazy">` : '<span></span>'}<b>${esc(h.title)}</b><span>${esc(money(Math.round(parseFloat(h.price) * 100)))}</span></a>`).join('')
            : `<p class="search-hint">${esc(S.searchNone)}</p>`;
        } catch (e) { /* aborted */ }
      }, 180);
    });
  }

  /* ---------------- Sliders ---------------- */
  function initHero() {
    $$('[data-hero-slider]').forEach(root => {
      const slides = $$('.hs-slide', root), dots = $$('.hs-dot', root), curEl = $('[data-hs-cur]', root);
      if (slides.length < 2) return;
      const DELAY = +root.dataset.delay || 6000;
      let cur = 0, timer = 0;
      const hydrate = () => $$('img[data-src]', root).forEach(i => { if (i.dataset.srcset) i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); i.removeAttribute('data-srcset'); });
      const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(hydrate, { timeout: 2500 }) : setTimeout(hydrate, 1200));
      if (document.readyState === 'complete') idle(); else addEventListener('load', idle, { once: true });
      const restart = () => {
        clearTimeout(timer);
        root.classList.remove('run'); void root.offsetWidth; root.classList.add('run');
        if (!reduce) timer = setTimeout(() => show(cur + 1), DELAY);
      };
      function show(n) {
        hydrate();
        const next = (n + slides.length) % slides.length;
        if (next === cur) return;
        root.classList.add('moved');
        const old = slides[cur];
        old.classList.remove('on'); old.classList.add('leaving');
        setTimeout(() => old.classList.remove('leaving'), 1100);
        cur = next;
        slides.forEach((s, i) => {
          s.classList.toggle('on', i === cur);
          s.setAttribute('aria-hidden', String(i !== cur));
          $$('a', s).forEach(a => (i === cur ? a.removeAttribute('tabindex') : (a.tabIndex = -1)));
        });
        dots.forEach((d, i) => { d.classList.toggle('on', i === cur); d.setAttribute('aria-selected', String(i === cur)); });
        if (curEl) curEl.textContent = String(cur + 1).padStart(2, '0');
        restart();
      }
      $$('[data-step]', root).forEach(b => b.addEventListener('click', () => show(cur + +b.dataset.step)));
      dots.forEach(d => d.addEventListener('click', () => show(+d.dataset.go)));
      let x0 = 0, y0 = 0, tracking = false;
      root.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; tracking = true; }, { passive: true });
      root.addEventListener('pointerup', e => {
        if (!tracking) return; tracking = false;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(cur + ((dx < 0) !== rtl ? 1 : -1));
      }, { passive: true });
      root.addEventListener('pointercancel', () => (tracking = false));
      root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { clearTimeout(timer); root.classList.add('paused'); } });
      root.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { root.classList.remove('paused'); restart(); } });
      new IntersectionObserver(([en]) => (en.isIntersecting ? restart() : clearTimeout(timer))).observe(root);
      document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(timer) : restart()));
      if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:block:select', e => { const i = slides.indexOf(e.target); if (i >= 0) { show(i); clearTimeout(timer); } });
    });
  }
  function initReviews() {
    $$('[data-reviews]').forEach(section => {
      const track = $('.rv-track', section);
      const cards = $$('.rv-card', track), dots = $$('[data-dot]', section);
      if (!cards.length) return;
      let timer = 0;
      const current = () => {
        const tr = track.getBoundingClientRect();
        let best = 0, dist = Infinity;
        cards.forEach((c, i) => { const r = c.getBoundingClientRect(); const d = Math.abs(rtl ? tr.right - r.right : r.left - tr.left); if (d < dist) { dist = d; best = i; } });
        return best;
      };
      const go = i => {
        const c = cards[(i + cards.length) % cards.length];
        const tr = track.getBoundingClientRect(), r = c.getBoundingClientRect();
        track.scrollBy({ left: rtl ? r.right - tr.right : r.left - tr.left, behavior: 'smooth' });
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = current(); dots.forEach((d, k) => d.classList.toggle('on', k === i)); }); }, { passive: true });
      const atEnd = () => (rtl ? Math.abs(track.scrollLeft) : track.scrollLeft) + track.clientWidth >= track.scrollWidth - 8;
      const restart = () => { clearInterval(timer); if (!reduce) timer = setInterval(() => { if (!document.hidden) go(atEnd() ? 0 : current() + 1); }, 5000); };
      $$('[data-rv]', section).forEach(b => b.addEventListener('click', () => { go(current() + +b.dataset.rv); restart(); }));
      dots.forEach(d => d.addEventListener('click', () => { go(+d.dataset.dot); restart(); }));
      section.addEventListener('pointerenter', () => clearInterval(timer));
      section.addEventListener('pointerleave', restart);
      section.addEventListener('focusin', () => clearInterval(timer));
      new IntersectionObserver(([en]) => (en.isIntersecting ? restart() : clearInterval(timer))).observe(section);
    });
  }

  /* ---------------- Wishlist page ---------------- */
  async function initWishlistPage() {
    const root = $('[data-wishlist]');
    if (!root) return;
    const grid = $('#wishGrid', root);
    const render = async () => {
      const w = wish.get();
      $('[data-wish-empty]', root).hidden = w.length > 0;
      $('[data-wish-bar]', root).hidden = w.length === 0;
      const sug = $('[data-wish-suggest]', root); if (sug) sug.hidden = w.length > 0;
      const have = new Set($$('.pc', grid).map(c => c.dataset.handle));
      $$('.pc', grid).forEach(c => { if (!w.includes(c.dataset.handle)) c.remove(); });
      for (const h of w) {
        if (have.has(h)) continue;
        try {
          const html = await fetch(`${K.root.replace(/\/$/, '')}/products/${h}?section_id=product-card-render`).then(r => (r.ok ? r.text() : ''));
          const t = document.createElement('div'); t.innerHTML = html;
          const card = t.querySelector('.pc');
          if (card) { card.classList.add('in'); grid.appendChild(card); } else wish.set(wish.get().filter(x => x !== h));
        } catch (e) { /* offline */ }
      }
      syncWish(); watchGlow(grid);
    };
    root._render = render;
    render();
  }

  /* ---------------- Global click delegation ---------------- */
  document.addEventListener('click', async e => {
    const t = e.target;
    const opener = t.closest('[data-open]');
    if (opener) { e.preventDefault(); if (opener.dataset.open === 'cart') shake(opener); open(opener.dataset.open); return; }
    if (t.closest('[data-close]')) { close(); return; }
    const w = t.closest('[data-wish]');
    if (w) {
      e.preventDefault();
      const added = wish.toggle(w.dataset.wish);
      if (added) { hearts(w); toast(S.wishAdded); } else toast(S.wishRemoved);
      pop(w); syncWish();
      const wl = $('[data-wishlist]'); if (wl && wl._render) wl._render();
      return;
    }
    const q = t.closest('[data-quick]');
    if (q) { e.preventDefault(); shake(q); quickView(q.dataset.quick); return; }
    const cq = t.closest('[data-cq]');
    if (cq) {
      const line = +cq.dataset.line, cur = +cq.dataset.q || 0;
      const quantity = cq.dataset.cq === 'rm' ? 0 : cq.dataset.cq === '+' ? cur + 1 : cur - 1;
      cq.disabled = true;
      try { cartState = await api(R.cartChange, { line, quantity }); } catch (err) { toast(err.description || S.unavailable); }
      renderCart();
      return;
    }
    const cp = t.closest('[data-copy]');
    if (cp) {
      try { await navigator.clipboard.writeText(cp.dataset.copy); } catch (err) { /* blocked */ }
      pop(cp); cp.classList.add('done'); setTimeout(() => cp.classList.remove('done'), 1600);
      toast(S.copied + ': ' + cp.dataset.copy);
    }
  });

  /* ---------------- Card colour dots: show that colour's photo ---------------- */
  function cardSwatch(sw) {
    const card = sw.closest('.pc');
    const img = card && card.querySelector('.pc-media .img-1');
    if (!img || !sw.dataset.img) return;
    img.removeAttribute('srcset');
    img.src = sw.dataset.img;
    card.classList.add('sw-picked');
    $$('.sw-row .sw', card).forEach(x => x.classList.toggle('on', x === sw));
  }
  document.addEventListener('click', e => { const sw = e.target.closest('.sw-row .sw[data-img]'); if (sw) { e.preventDefault(); cardSwatch(sw); } });
  document.addEventListener('keydown', e => { if (e.key !== 'Enter' && e.key !== ' ') return; const sw = e.target.closest && e.target.closest('.sw-row .sw[data-img]'); if (sw) { e.preventDefault(); cardSwatch(sw); } });
  document.addEventListener('pointerover', e => { if (e.pointerType !== 'mouse') return; const sw = e.target.closest('.sw-row .sw[data-img]'); if (sw) cardSwatch(sw); });

  /* ---------------- Collection: sort & filters ---------------- */
  function initCollection() {
    const sort = $('[data-sort]');
    sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
    const f = $('[data-auto-submit]');
    if (f) {
      let t = 0;
      const submit = () => { const u = new URL(f.action, location.origin); new FormData(f).forEach((v, k) => { if (v !== '') u.searchParams.append(k, v); }); location.href = u.toString(); };
      f.addEventListener('change', e => { clearTimeout(t); t = setTimeout(submit, e.target.type === 'number' ? 700 : 0); });
    }
  }

  /* ---------------- Misc ---------------- */
  // grid switchers (6/5/4/3/2/list)
  $$('[data-grid-switch]').forEach(sw => {
    const grid = document.getElementById(sw.dataset.gridSwitch);
    if (!grid) return;
    const key = 'kh_cols_' + sw.dataset.gridSwitch;
    const apply = n => { grid.dataset.cols = String(n); $$('.gs-btn', sw).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.cols === n))); };
    let saved = 0; try { saved = +(localStorage.getItem(key) || 0); } catch (e) { /* */ }
    const vw = innerWidth, fit = n => (vw < 768 ? Math.min(n, 2) : vw < 1024 ? Math.min(n, 3) : n);
    apply(fit(saved || +(sw.dataset.default || 4)));
    sw.addEventListener('click', e => { const b = e.target.closest('.gs-btn'); if (!b) return; apply(+b.dataset.cols); try { localStorage.setItem(key, b.dataset.cols); } catch (err) { /* */ } });
  });
  // header shadow on scroll
  const header = $('#siteHeader');
  let ticking = false;
  addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { header && header.classList.toggle('scrolled', scrollY > 20); ticking = false; }); }, { passive: true });
  // reveal on scroll
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  const observe = (r = document) => $$('.reveal:not(.in)', r).forEach(el => (io ? io.observe(el) : el.classList.add('in')));
  // animated card glow only on screen
  const glowIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => en.target.classList.toggle('live', en.isIntersecting)), { rootMargin: '80px' }) : null;
  function watchGlow(r = document) { $$('.glow-auto', r).forEach(el => (glowIO ? glowIO.observe(el) : el.classList.add('live'))); observe(r); }
  // decorative animations start when idle
  const ready = () => document.documentElement.classList.add('ready');
  addEventListener('load', () => ('requestIdleCallback' in window ? requestIdleCallback(ready, { timeout: 2500 }) : setTimeout(ready, 1200)), { once: true });
  ['pointerdown', 'scroll', 'keydown', 'touchstart'].forEach(ev => addEventListener(ev, ready, { once: true, passive: true }));
  // mega menu thumbnails on first open
  $$('[data-mega]').forEach(m => {
    const load = () => $$('img[data-src]', m).forEach(i => { i.src = i.dataset.src; i.removeAttribute('data-src'); });
    m.parentElement.addEventListener('pointerenter', load, { once: true });
    m.parentElement.addEventListener('focusin', load, { once: true });
  });
  // Google Maps embed once visible
  $$('.map-frame iframe[data-src]').forEach(f => new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); setTimeout(() => { f.src = f.dataset.src; f.removeAttribute('data-src'); }, 300); } }, { rootMargin: '200px' }).observe(f.parentElement));
  // re-init inside the theme editor
  document.addEventListener('shopify:section:load', e => { watchGlow(e.target); initHero(); initReviews(); initBundles(); syncWish(); });

  /* ---------------- Boot ---------------- */
  watchGlow();
  syncWish();
  initProduct();
  initBundles();
  initSearch();
  initHero();
  initReviews();
  initCollection();
  initWishlistPage();
  refreshCart();
  addEventListener('storage', e => { if (e.key === 'kh_wish') syncWish(); });
  addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });
})();
